import React from "react";
import "./footer.style.sass";
import {
	Col,
	Row,
	Form,
	FormGroup,
	Alert,
	FormControl,
	Button,
	Icon,
	Whisper,
	Tooltip,
} from "rsuite";
import namad1 from "../../assets/image/namad-1.png";
import namad2 from "../../assets/image/namad-2.png";
import linkdata from "../../data/links/siteLinks.json";
import AppData from "../../data/aplication/aplication.json";
import { connect } from "react-redux";
import { ChangeActiveLink } from "../../redux/site/site.actions";
import { Link } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { selectBaseInfo } from "../../redux/site/site.selector";
import { AddIcon } from "../../script";
import RingLoader from "react-spinners/RingLoader";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import Axios from "axios";
import { HandleErorr, Setting } from "../../setting";

class Footer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			formValue: {
				email: "",
				LinkData: "",
			},
			showOnlinePayment: 0,
		};
	}

	componentDidMount() {
		Axios.get(`${Setting.apiUrl}api/downloadApp/list`)
			.then((res) => {
				this.setState({
					LinkData: res.data,
				});
			})
			.catch((res) => HandleErorr(res));
		Axios.get(`${Setting.apiUrl}api/setting/list`)
			.then((res) => {
				this.setState({
					showOnlinePayment: res.data.show_online_payment,
				});
			})
			.catch((err) => {});
	}

	HandleSubmit = () => {
		Axios.post(
			`${Setting.apiUrl}api/contactUs/email`,
			{
				email: `${this.state.formValue.email}`,
			},
			{ Accept: "application.json", contentType: "application.json" }
		)
			.then((res) => {
				if (res.status === 200) {
					Alert.success("ایمیل شما با موفقیت ثبت شد");
				}
			})
			.catch((res) => HandleErorr(res));
	};

	render() {
		const { changeAcrive, baseInfo } = this.props;
		const { LinkData } = this.state;
		const override = css`
			display: block;
			margin: 40px auto;
			border-color: red;
		`;

		const tooltip = (item) => <Tooltip>{item.name}</Tooltip>;
		return (
			<div className="footer-main">
				<div className="footer-content">
					<Row>
						<Col
							md={5}
							sm={24}
						>
							<div className="namads">
								<a href="/">
									<div className="namad namad-firstChild">
										<img
											id="fukzjzpejzpergvjoeuk"
											style={{ cursor: "pointer" }}
											onClick={() =>
												window.open(
													"https://logo.samandehi.ir/Verify.aspx?id=67738&p=gvkajyoejyoexlaomcsi",
													"Popup",
													"toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
												)
											}
											alt="samandehi-namad"
											src={namad1}
										/>
									</div>
								</a>
								<a
									referrerPolicy="origin"
									target="_blank"
									href="https://trustseal.enamad.ir/?id=52065&amp;Code=ZuVqLXGFEgKefFUp7ydw"
								>
									<img
										referrerPolicy="origin"
										src="https://Trustseal.eNamad.ir/logo.aspx?id=52065&amp;Code=ZuVqLXGFEgKefFUp7ydw"
										alt=""
										style={{ cursor: "pointer" }}
										id="ZuVqLXGFEgKefFUp7ydw"
									/>
								</a>
							</div>
						</Col>
						<Col
							md={4}
							sm={12}
						>
							<div className="links-area">
								<h5
									onClick={() => changeAcrive("download")}
									className="get-on-title"
								>
									دانلود اپلیکیشن
								</h5>
								{LinkData ? (
									LinkData.map((item) => (
										<div
											key={item.id}
											className="get-on-img"
										>
											<a
												href={item.url}
												target="_blank"
												rel="noreferrer"
											>
												<img
													src={`${Setting.apiUrl}/${item.img}`}
													alt="get on logo"
												/>
											</a>
										</div>
									))
								) : (
									<GridLoader
										css={override}
										size={15}
										margin={8}
										color="#FF8F3C"
									/>
								)}
							</div>
						</Col>
						<Col
							md={3}
							sm={12}
						>
							<div className="links-area">
								<h5
									onClick={() => changeAcrive("home")}
									className="get-on-title"
								>
									زیتونیکس
								</h5>
								<ul>
									{linkdata.map((item) =>
										Number(item.id) !== 5 ? (
											<li
												key={item.id}
												className="need-padding-top"
											>
												<Link to={item.link}>{item.text}</Link>
											</li>
										) : Number(this.state.showOnlinePayment) === 1 ? (
											<li
												key={item.id}
												className="need-padding-top"
											>
												<Link to={item.link}>{item.text}</Link>
											</li>
										) : (
											""
										)
									)}
								</ul>
							</div>
						</Col>
						<Col
							md={6}
							sm={24}
						>
							<div className="contact-with-us">
								<h5
									onClick={() => changeAcrive("contact")}
									className="with-us-title"
								>
									تماس با ما
								</h5>
								{baseInfo ? (
									JSON.parse(baseInfo[0].contactInfo).map((item, i) => (
										<div
											key={i}
											className="with-us-items"
										>
											<p>
												{item.key} : {item.value}
											</p>
										</div>
									))
								) : (
									<GridLoader
										css={override}
										size={15}
										margin={8}
										color="#FF8F3C"
									/>
								)}
							</div>
						</Col>
						<Col
							md={6}
							sm={24}
						>
							<div className="send-your-mail">
								<h5 className="get-on-title">خبر نامه</h5>
								<Form
									onChange={(value) => this.setState({ formValue: value })}
									formValue={this.state.formValue}
									className="form-send-mail"
									onSubmit={this.HandleSubmit}
								>
									<FormGroup className="formGroup-of-send">
										<FormControl
											className="input-of-send"
											name="email"
											type="email"
											placeholder="ایمیل"
										/>
									</FormGroup>
									<Button type="submit">
										<Icon icon="envelope-o" />
									</Button>
								</Form>
							</div>
							<div className="network-social">
								<h5 className="get-on-title">شبکه های اجتماعی</h5>
								<div className="social-area">
									{baseInfo ? (
										AddIcon(JSON.parse(baseInfo[0].social_networks)).map(
											(item, i) => (
												<Whisper
													key={i}
													placement="top"
													trigger="hover"
													speaker={tooltip(item)}
												>
													<a href={item.href}>
														<Icon icon={item.icon} />
													</a>
												</Whisper>
											)
										)
									) : (
										<RingLoader
											css={override}
											size={35}
											color="#FF8F3C"
										/>
									)}
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

const mapStateToProps = createStructuredSelector({
	baseInfo: selectBaseInfo,
});

const mapDispatchToProps = (dispatch) => ({
	changeAcrive: (key) => dispatch(ChangeActiveLink(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
